module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/characters/apprenticesFlexArms-4aeefe98ba101c125fbc6e150654e893.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/characters/apprenticesFlexArms.png
// module id = 907
// module chunks = 2